import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { uploadUrl: String }

  connect() {
    if (typeof EasyMDE === "undefined") return
    this.editor = new EasyMDE({
      element: this.element,
      autofocus: false,
      spellChecker: false,
      status: ["lines", "words", "cursor"],
      uploadImage: true,
      imageUploadFunction: (file, onSuccess, onError) => {
        this.uploadImage(file).then(onSuccess).catch(err => onError(err.message))
      },
    })
  }

  disconnect() {
    if (this.editor) {
      this.editor.toTextArea()
      this.editor = null
    }
  }

  async uploadImage(file) {
    const presignUrl = new URL(this.uploadUrlValue, window.location.origin)
    presignUrl.searchParams.set("name", file.name)
    presignUrl.searchParams.set("type", file.type)
    const presignRes = await fetch(presignUrl.toString())
    if (!presignRes.ok) throw new Error(`Presign failed: ${presignRes.status}`)
    const formobj = await presignRes.json()

    const data = new FormData()
    for (const [k, v] of Object.entries(formobj.fields)) data.append(k, v)
    data.append("file", file)

    const uploadRes = await fetch(formobj.url, { method: "POST", body: data })
    if (uploadRes.status !== 204) {
      throw new Error(`Upload failed: ${uploadRes.status}`)
    }
    if (!formobj.proxy_url) throw new Error("Server did not return proxy_url")
    return formobj.proxy_url
  }
}
